import type { EnemyKind } from './enemies'
import type { TowerKind } from './towers'

export interface RunTelemetry {
  readonly towerShots: Record<TowerKind, number>
  readonly towerDamage: Record<TowerKind, number>
  readonly towerKills: Record<TowerKind, number>
  readonly abilitiesUsed: Record<TowerKind, number>
  readonly enemyKills: Record<EnemyKind, number>
  readonly breaches: Record<EnemyKind, number>
  readonly eliteKills: number
  readonly eliteBreaches: number
  readonly riskyEncountersCleared: number
  readonly encounterBonus: number
  readonly peakThreatLevel: number
  readonly threatEscalations: number
  readonly coreDamageTaken: number
  readonly towersBuilt: number
  readonly towersUpgraded: number
  readonly towersRecycled: number
}

export function emptyRunTelemetry(): RunTelemetry {
  return {
    towerShots: { SOL: 0, ETH: 0, BTC: 0 },
    towerDamage: { SOL: 0, ETH: 0, BTC: 0 },
    towerKills: { SOL: 0, ETH: 0, BTC: 0 },
    abilitiesUsed: { SOL: 0, ETH: 0, BTC: 0 },
    enemyKills: { BOT: 0, PAPER_HAND: 0, FUD_BOT: 0, LIQUIDATOR: 0, WHALE: 0 },
    breaches: { BOT: 0, PAPER_HAND: 0, FUD_BOT: 0, LIQUIDATOR: 0, WHALE: 0 },
    eliteKills: 0,
    eliteBreaches: 0,
    riskyEncountersCleared: 0,
    encounterBonus: 0,
    peakThreatLevel: 0,
    threatEscalations: 0,
    coreDamageTaken: 0,
    towersBuilt: 0,
    towersUpgraded: 0,
    towersRecycled: 0,
  }
}
